module.exports = __webpack_public_path__ + "static/media/loading.31d1639d.svg";